export default __webpack_public_path__ + "static/media/forthCard.968ec66b.png";